import React from 'react';

interface DescriptionProps {
  headline?: string;
  children?: React.ReactNode;
}

const Description: React.FC<DescriptionProps> = (props) => {
  const { headline, children } = props;

  return (
    <>
      <div className="">
        {headline && (
          <>
            <h2 className="mb-6 text-2xl font-medium uppercase">{headline}</h2>
          </>
        )}
        {children}
      </div>
    </>
  );
};
export default Description;
